import fetch from 'services'

export const getCompositions = (region) => fetch(`/compositions?include_stock=True&stock_region=${region}`)

export const deleteComposition = (id) =>
    fetch(`/compositions/${id}`, {
        method: 'DELETE',
    })

export const saveComposition = (compositionSaveData, isNew) => {
    let method = 'POST'
    let url = `/compositions`

    if (!isNew) {
        method = 'PUT'
        url = `/compositions/${compositionSaveData.compositionId}`
    }

    return fetch(url, {
        method,
        data: compositionSaveData,
    })
}

export const getSharedCompositions = (uuid) => fetch(`/compositions/shared/${uuid}`)

export const getCompiledComposition = (id) =>
    fetch(`/compositions/${id}/compiled/`, {
        params: {
            geometry_type: '3d,2d_wall',
        },
    })
